export default "__VITE_ASSET__75bc978a__"